<app-dialog-container>
  <div fxLayout="column" fxLayoutGap="24px" class="form-container">
    <div fxLayout="row" fxLayoutAlign="start center">
      <h1 mat-card-title class="primary-title">{{ title }}</h1>
    </div>
    <div [formGroup]="form" fxLayout="column" fxLayoutGap="24px"
      class="scrollable-content">
      <!-- Seção principal do formulário -->
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px">
        <app-image
          *ngIf="form.get('typeQuestion')?.value !== 'BRIEFING'"
          fxFlex="30"
          fxFlex.lt-md="100"
          class="image-content"
          [config]="getFieldConfig('image')"
          [typeCes]="typeCes"
          [group]="form">
        </app-image>
        <div fxFlex="70" fxFlex.lt-md="100" fxLayout="column"
          fxLayoutGap="16px">
          <app-input [config]="getFieldConfig('description')"
            [typeCes]="typeCes" [group]="form"></app-input>
          <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
            <!-- Invertendo a posição: typeQuestion à esquerda e limit à direita -->
            <app-select
              fxFlex="100"
              fxFlex.lt-sm="100"
              [config]="getFieldConfig('typeQuestion')"
              [typeCes]="typeCes"
              [group]="form"
              (selectionChange)="onTypeQuestionChange($event)">
            </app-select>
            <app-select
              *ngIf="!['BRIEFING', 'REUNIÃO'].includes(form.get('typeQuestion')?.value)"
              fxFlex="100"
              fxFlex.lt-sm="100"
              [config]="getFieldConfig('limit')"
              [typeCes]="typeCes"
              [group]="form">
            </app-select>
          </div>
        </div>
      </div>

      <!-- Áreas específicas do formulário com scroll interno -->
      <div class="dynamic-content">
        <!-- Mostrar Assuntos Abordados se for CRIAR PERGUNTA ou PERGUNTA -->
        <mat-card *ngIf="showCheckboxes" class="mat-elevation-z1">
          <mat-card-header>
            <mat-card-title>Assuntos Abordados</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="16px grid">
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox
                  formControlName="financial">Financeiro</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox formControlName="legal">Jurídico</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox
                  formControlName="consultant">Consultor</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox formControlName="partner">Parceiro</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox
                  formControlName="representative">Representante</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox
                  formControlName="accounting">Contábil</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox
                  formControlName="solutions">Soluções</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox formControlName="plans">Planos</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox formControlName="dashboard">Painel</mat-checkbox>
              </div>
              <div fxFlex="25" fxFlex.lt-md="33" fxFlex.lt-sm="50">
                <mat-checkbox formControlName="support">Suporte</mat-checkbox>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mostrar apenas se for TODOS ou PERGUNTA -->
        <mat-card *ngIf="showFieldSelection" class="mat-elevation-z1">
          <mat-card-header>
            <mat-card-title>Escolha os Campos para o Novo
              Formulário</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="16px grid">
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-select [config]="getFieldConfig('enterprise')"
                  [typeCes]="typeCes" [group]="form"></app-select>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-select [config]="getFieldConfig('telephone')"
                  [typeCes]="typeCes" [group]="form"></app-select>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-select [config]="getFieldConfig('instagram')"
                  [typeCes]="typeCes" [group]="form"></app-select>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-select [config]="getFieldConfig('question')"
                  [typeCes]="typeCes" [group]="form"></app-select>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Campo para adicionar nova pergunta -->
        <mat-card *ngIf="showNewQuestion" class="mat-elevation-z1">
          <mat-card-header>
            <mat-card-title>Adicionar Nova Pergunta</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row" fxLayout.lt-sm="column"
              fxLayoutAlign="start center" fxLayoutGap="16px">
              <app-input fxFlex="70" fxFlex.lt-sm="100"
                [config]="getFieldConfig('newQuestion')"
                [typeCes]="typeCes" [group]="form"></app-input>
              <button mat-raised-button (click)="addNewQuestion()"
                class="add-button">Adicionar</button>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Exibe as perguntas adicionadas dinamicamente -->
        <mat-card *ngIf="customQuestions.length > 0"
          class="mat-elevation-z1 custom-questions-card">
          <mat-card-header>
            <mat-card-title>Perguntas Adicionadas</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="questions-container">
              <div *ngFor="let question of customQuestions; let i = index"
                fxLayout="row" fxLayout.lt-sm="column"
                fxLayoutAlign="start center" fxLayoutGap="16px"
                class="question-item">
                <mat-form-field appearance="outline" fxFlex="70"
                  fxFlex.lt-sm="100">
                  <mat-label>{{ question }}</mat-label>
                  <input matInput
                    [formControlName]="customQuestionControls[i].controlName" />
                </mat-form-field>
                <button mat-icon-button color="warn" (click)="removeQuestion(i)"
                  aria-label="Remover pergunta">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Se for tipo REUNIÃO, exibir os campos específicos -->
        <mat-card *ngIf="showMettingFields" class="mat-elevation-z1">
          <mat-card-header>
            <mat-card-title>Detalhes da Reunião</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="16px grid">
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-input
                  [config]="getFieldConfig('meetingDateTime')"
                  [typeCes]="typeCes" [group]="form">
                </app-input>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <!-- Adicionando comentário de debug -->
                <!-- Tipo selecionado: {{ form.get('type')?.value | json }} -->
                <app-input
                  [config]="getFieldConfig('type')"
                  [typeCes]="typeCes" [group]="form"
                  (selectionChange)="onSystemTypeChange($event)">
                </app-input>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <!-- Adicionando comentário de debug -->
                <!-- Sistema selecionado: {{ form.get('system')?.value | json }} -->
                <app-input
                  [config]="getFieldConfig('system')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectSystem($event)">
                </app-input>
              </div>
              <div fxFlex="25" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <!-- Adicionando comentário de debug -->
                <!-- Parceiro selecionado: {{ form.get('partners')?.value | json }} -->
                <app-input
                  [config]="getFieldConfig('partners')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectPartners($event)">
                </app-input>
              </div>
              <div fxFlex="100" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-input
                  [config]="getFieldConfig('linkMeeting')"
                  [typeCes]="typeCes" [group]="form">
                </app-input>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Se for tipo BRIEFING, exibir os campos específicos -->
        <mat-card *ngIf="showBriefingFields" class="mat-elevation-z1">
          <mat-card-header>
            <mat-card-title>Detalhes do Briefing</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="16px grid">
              <div fxFlex="33.33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-input
                  [config]="getFieldConfig('briefingCustomer')"
                  [typeCes]="typeCes"
                  [group]="form"
                  (onSelect)="selectBriefingCustomer($event)">
                  <ng-container *ngIf="form.get('briefingCustomerName')?.value">
                    <div class="selected-item-name">
                      Cliente selecionado: {{
                      form.get('briefingCustomerName')?.value }}
                    </div>
                  </ng-container>
                </app-input>
              </div>
              <div fxFlex="33.33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-input
                  [config]="getFieldConfig('briefingSystem')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectSystem($event)">
                  <ng-container *ngIf="form.get('briefingSystemName')?.value">
                    <div class="selected-item-name">
                      Solução selecionada: {{
                      form.get('briefingSystemName')?.value }}
                    </div>
                  </ng-container>
                </app-input>
              </div>
              <div fxFlex="33.33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
                <app-input
                  [config]="getFieldConfig('briefingPartner')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectPartners($event)">
                  <ng-container *ngIf="form.get('briefingPartnerName')?.value">
                    <div class="selected-item-name">
                      Parceiro selecionado: {{
                      form.get('briefingPartnerName')?.value }}
                    </div>
                  </ng-container>
                </app-input>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Botões sempre visíveis na parte inferior -->
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
      class="action-buttons">
      <button class="create" mat-raised-button
        [disabled]="form.disabled"
        (click)="generateAndSaveForm()">
        <span *ngIf="!form.disabled">{{ data.type === 'EDIT' ? 'ATUALIZAR' :
          'CRIAR' }}</span>
        <span *ngIf="form.disabled">PROCESSANDO...</span>
      </button>
    </div>
  </div>
</app-dialog-container>
